import { InjectionToken } from '@angular/core';

import type { SbbHeader } from './header.component';

export const SBB_HEADER = new InjectionToken<SbbHeader>('SBB_HEADER');
